package tables.product

import emotion.react.css
import kotlinx.browser.window
import models.ProductModel
import org.w3c.fetch.RequestInit
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.table
import react.dom.html.ReactHTML.tbody
import react.dom.html.ReactHTML.td
import react.dom.html.ReactHTML.th
import react.dom.html.ReactHTML.thead
import react.dom.html.ReactHTML.tr
import react.useEffect
import react.useState
import token
import urlAddress
import web.cssom.BorderCollapse
import web.cssom.Color
import web.cssom.TextAlign
import web.cssom.px
import web.html.InputType

external interface ProductProps : Props

val ProductTable = FC<ProductProps> {

    val (productModels, setProductModels) = useState(emptyList<ProductModel>())
    var productName by useState("")
    var categoryName by useState("")
    var isModalOpen: ProductModel? by useState(null)
    var isModalOpenCreate by useState(false)

    fun loadProducts() {
        window.fetch(urlAddress + "api/products", RequestInit(
            method = "GET",
            headers = web.http.Headers().apply {
                append("Authorization", "Bearer $token")
            }
        ))
            .then { response -> response.json() }
            .then { data ->
                val newResultList = (data as? Array<dynamic> ?: emptyArray()).mapNotNull {
                    ProductModel(
                        it.id as? Int ?: 0,
                        it.name as? String ?: "",
                        it.category as? String ?: ""
                    )
                }
                setProductModels(newResultList)
            }
    }

    useEffect(productModels.isEmpty()) {
        loadProducts()
    }

    UpdateProductModal {
        productModel = isModalOpen
        listProductModel = productModels
        onClose = {
            isModalOpen = null
        }
        onUpdate = {
            loadProducts()
        }

    }

    CreateProductModal {
        isOpen = isModalOpenCreate
        listProductModel = productModels
        onClose = {
            isModalOpenCreate = false
        }
        onUpdate = {
            loadProducts()
        }
    }

    div {
        div {
            +"Введите наименование Продукта:"
            input {
                css {
                    fontSize = 14.px
                }
                value = productName
                type = InputType.text
                onChange = { event ->
                    productName = event.target.value
                }
            }
            button {
                +"Добавить"
                onClick = {
                    isModalOpenCreate = true
                }
            }
        }

        div {
            +"Введите наименование Категории:"
            input {
                css {
                    fontSize = 14.px
                }
                value = categoryName
                type = InputType.text
                onChange = { event ->
                    categoryName = event.target.value
                }
            }
        }

        table {
            border = 1
            css {
                borderColor = Color("#000")
                borderCollapse = BorderCollapse.collapse
                textAlign = TextAlign.center
            }
            thead {
                tr {
                    th { +"Наименование" }
                    th { +"Категория" }
                    th { +"Действие" }
                }
            }
            tbody {
                productModels.filter {
                    it.name.lowercase().contains(productName.lowercase()) and it.category.lowercase()
                        .contains(categoryName.lowercase())
                }.forEach { item ->
                    tr {
                        td { +item.name }
                        td { +item.category }
                        td {
                            button {
                                css {
                                    margin = 5.px
                                    marginBottom = 5.px
                                    fontSize = 14.px
                                }
                                +"✏️"
                                onClick = {
                                    isModalOpen = item
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

